export default class CardLink {
  constructor() {
    this.selector = '.c-card-link';

    this.selectors = {
      links: '.c-card-link__title',
    };

    this.classNames = {
      expanded: 'expanded',
    };
  }

  bootstrap() {
    this.initCardLinks();
  }

  initCardLinks() {
    const blocks = [ ...document.querySelectorAll(this.selector) ];

    if (blocks.length === 0) {
      return;
    }

    blocks.forEach(block => {
      const links = block.querySelector(this.selectors.links);
      let touchstartX = 0;
      let touchendX = 0;
      const that = this;

      const handleGesture = function () {
        if (touchendX < touchstartX) {
          block.classList.add(that.classNames.expanded);
        }

        if (touchendX > touchstartX) {
          block.classList.remove(that.classNames.expanded);
        }
      };

      if (links.length === 0) {
        return;
      }

      links.addEventListener('click', () => {
        block.classList.toggle(this.classNames.expanded);
      });

      links.addEventListener('touchstart', target => {
        touchstartX = target.changedTouches[0].screenX;
      });

      links.addEventListener('touchend', target => {
        touchendX = target.changedTouches[0].screenX;
        handleGesture();
      });
    });
  }
}
